import { mapState } from 'vuex';
export default {
  name: 'ViewNiotaClassicDevicesDeviceUpload',
  props: {},
  data: function () {
    return {
      limit: 50,
      showForm: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    headerBG() {
      return './img/dtwin-factory1.png';
    }
  },
  methods: {
    backToList() {
      this.$router.push({
        path: '/niota-classic/devices'
      });
    },
    uploadedFile(csv) {
      if (csv) {
        const rows = csv.split('\n');
        // 2502 rows because 2500 devices + header + one empty row from split
        if (rows.length > 2502) {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.errors.tooManyRows'), 'error');
          return;
        }
      }
      this.showForm = true;
      this.$refs.uploadForm.uploadedFile(csv);
    }
  }
};